import { render, staticRenderFns } from "./EditConnections.vue?vue&type=template&id=b7b87da8"
import script from "./EditConnections.vue?vue&type=script&lang=js"
export * from "./EditConnections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports